import React, { useEffect } from "react";
import { deepmerge } from "@mui/utils";
import { ThemeProvider, createTheme, Palette } from "@mui/material/styles";
import { useAppDispatch, useAppSelector } from "../../custom-hooks/redux/redux";
import { themeSlice } from "../redux/reducers/Theme/ThemeSlice";

const MuiThemeProvider = ({ children }: { children: JSX.Element }) => {
  const dispatch = useAppDispatch();
  const { palette, components, typography, shape } = useAppSelector((state) => state.themeReducer);
  const { setPalette } = themeSlice.actions;

  useEffect(() => {
    const localStoragePalette: null | Palette = !!localStorage.getItem("palette")
      ? JSON.parse(localStorage.getItem("palette") as string)
      : null;

    if (localStoragePalette) {
      if (!!localStoragePalette.actions) {
        dispatch(setPalette(localStoragePalette));
      } else {
        dispatch(
          setPalette({
            ...localStoragePalette,
            actions: themeSlice.getInitialState().palette.actions,
          } as Palette)
        );
      }
    }
  }, [dispatch, setPalette]);

  return <ThemeProvider theme={createTheme({ palette, components, typography, shape })}>{children}</ThemeProvider>;
};

export default MuiThemeProvider;
